import { Transform } from 'class-transformer';
import { OriginApp } from '../origin-app.enum';
import { sanitizeString } from '../utils';
import { OrderType } from './order-type.enum';

/**
 * Information of an order which can be manually set to be retried
 */
export class OrderHeaderDto {
  /**
   * Customer's PO number on the order
   * @example 'RETA21003132'
   */
  @Transform(({ value }) => sanitizeString(value))
  public customerPoNumber: string;

  public id: string;

  /**
   * Sales order number
   * @example 'SO01B0030048S'
   */
  public orderNumber: string;

  /**
   * Status of the order
   * @example 'missing'
   */
  public status: string;

  /**
   * Date of creation and first submission to dynamics of the order
   * @example '2022-01-01 12:00:00.000Z'
   */
  public createdAt: Date | string;

  /**
   * Date when the order is expected
   * @example '2022-01-01 12:00:00.000Z'
   */
  public dueDate: Date | string;

  /**
   * Type of the order
   * @example 'Re-order'
   */
  public type: OrderType;

  /**
   * Number of the order items already shipped
   * @example '5'
   */
  public itemShipped: number;

  /**
   * Number of the order items to be shipped
   * @example '5'
   */
  public quantityToShip: number;

  /**
   * Currency code of the order
   * @example 'EUR'
   */
  public currencyCode: string;

  /**
   * Status of the order document
   * @example 'Confirmation'
   */
  public documentStatus: string;

  /**
   * Total price of the order (the 'ConfirmAmount')
   * @example '10'
   */
  public total?: number;

  /**
   * Item quantities per SalesStatus
   * @example { _id: 'Canceled', quantity: 10}}
   */
  public quantitiesPerStatus?: { _id: string; quantity: number };

  /**
   * Origin of the order, where it was created
   * @example  "backstage"
   */
  public origin?: OriginApp;
}
